import validEmail from './valid-email'
import validPhone from './valid-phone'

export default function(patient) {
    if (patient.name.trim().indexOf(' ') < 0)
        return false

    // If the patient does not have either a phone or email
    if (! validEmail(patient.email) && ! validPhone(patient.phone))
        return false
    if (patient.email.length > 0 && ! validEmail(patient.email))
        return false
    if (patient.phone.length > 0 && ! validPhone(patient.phone))
        return false
    return true
}
